<template>
  <div class="Experiments w-full h-3/5">
    <div
      class="bg w-full h-20 flex justify-center items-center font-bold text-4xl"
    >
      Experiment Results
    </div>
    <div class="flex justify-center items-center flex-col">
      <div
        class="ExTitle text-3xl font-bold p-5 pt-10"
        id="Leaderboard"
        ref="leaderboard"
      >
        Leaderboard
      </div>
      <div class="leadContent w-7/12 text-justify">
        We evaluate the latest and most advanced LMMs and LLMs on the PathMMU
        test set, covering closed- and open-source models, focusing on their
        zero-shot capabilities in the field of pathology.
      </div>
    </div>

    <div
      class="w-full h-full flex justify-center items-center scale-75 relative bottom-20"
    >
      <div class="main" style="width: 95rem">
        <div class="table">
          <ul style="padding-top: 20px; background: rgb(221, 221, 221)">
            <li class="one"></li>
            <li v-for="(item, index) in titles" :key="index" class="two">
              <div v-if="index == 0">
                <P>Validation</P>
                <P>Overall</P>
              </div>
              <div v-else>
                <p>{{ item }}</p>
              </div>
            </li>
          </ul>
          <ul style="padding-bottom: 10px; background: rgb(221, 221, 221)">
            <li class="one"></li>
            <li v-for="(item, index) in titles" :key="index" class="two">
              <div v-if="index == 0">
                <div class="details">
                  <p>-</p>
                  <p class="text-lg" style="padding-top: 5px">( 710 )</p>
                </div>
              </div>
              <div v-else>
                <div class="name">
                  <div class="details">
                    <p>Tiny</p>
                    <p class="text-lg" style="padding-top: 5px">
                      ( {{ details[index].t1 }} )
                    </p>
                  </div>
                  <div class="details">
                    <p>All</p>
                    <p class="text-lg" style="padding-top: 5px">
                      ( {{ details[index].t2 }} )
                    </p>
                  </div>
                </div>
              </div>
            </li>
          </ul>

          <div class="table-2" style="background: rgb(241, 250, 251)">
            <ul v-for="item in table1" :key="item.prop" class="row-1" st>
              <li class="one pl-2">
                <a :href="item.link" target="_blank" class="text-blue-700">{{
                  item.prop
                }}</a>
              </li>
              <li v-for="(t, a) in item.data" :key="a" class="two">
                <div v-if="a == 0">
                  <div class="details">
                    <p
                      :class="[
                        item.data[a].isT1Bold ? 'FontBold' : '',
                        item.data[a].isT1Line ? 'FontLine' : '',
                      ]"
                    >
                      {{ item.sorce }}
                    </p>
                  </div>
                </div>
                <div v-else>
                  <div class="name">
                    <div class="details">
                      <p
                        :class="[
                          item.data[a].isT1Bold ? 'FontBold' : '',
                          item.data[a].isT1Line ? 'FontLine' : '',
                        ]"
                      >
                        {{ item.data[a].t1 }}
                      </p>
                    </div>
                    <div class="details">
                      <p
                        :class="[
                          item.data[a].isT2Bold ? 'FontBold' : '',
                          item.data[a].isT2Line ? 'FontLine' : '',
                        ]"
                      >
                        {{ item.data[a].t2 }}
                      </p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div class="title-2">
            Large Multimodal Models (LMMs): Text + Image as Input
          </div>

          <div class="table-2" style="background: rgb(249, 242, 248)">
            <ul v-for="item in table2" :key="item.prop" class="row-1">
              <li class="one pl-2">
                <a :href="item.link" target="_blank" class="text-blue-700">{{
                  item.prop
                }}</a>
              </li>
              <li v-for="(t, a) in item.data" :key="a" class="two">
                <div v-if="a == 0">
                  <div class="details">
                    <p
                      :class="[
                        item.data[a].isT1Bold ? 'FontBold' : '',
                        item.data[a].isT1Line ? 'FontLine' : '',
                      ]"
                    >
                      {{ item.sorce }}
                    </p>
                  </div>
                </div>
                <div v-else>
                  <div class="name">
                    <div class="details">
                      <p
                        :class="[
                          item.data[a].isT1Bold ? 'FontBold' : '',
                          item.data[a].isT1Line ? 'FontLine' : '',
                        ]"
                      >
                        {{ item.data[a].t1 }}
                      </p>
                    </div>
                    <div class="details">
                      <p
                        :class="[
                          item.data[a].isT2Bold ? 'FontBold' : '',
                          item.data[a].isT2Line ? 'FontLine' : '',
                        ]"
                      >
                        {{ item.data[a].t2 }}
                      </p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div class="title-2">
            Large Language Models (LLMs): Only Text as Input
          </div>

          <div class="table-2" style="background: rgb(241, 250, 251)">
            <ul v-for="item in table3" :key="item.prop" class="row-1">
              <li class="one pl-2">
                <a :href="item.link" target="_blank" class="text-blue-700">{{
                  item.prop
                }}</a>
              </li>
              <li v-for="(t, a) in item.data" :key="a" class="two">
                <div v-if="a == 0">
                  <div class="details">
                    <p
                      :class="[
                        item.data[a].isT1Bold ? 'FontBold' : '',
                        item.data[a].isT1Line ? 'FontLine' : '',
                      ]"
                    >
                      {{ item.sorce }}
                    </p>
                  </div>
                </div>
                <div v-else>
                  <div class="name">
                    <div class="details">
                      <p
                        :class="[
                          item.data[a].isT1Bold ? 'FontBold' : '',
                          item.data[a].isT1Line ? 'FontLine' : '',
                        ]"
                      >
                        {{ item.data[a].t1 }}
                      </p>
                    </div>
                    <div class="details">
                      <p
                        :class="[
                          item.data[a].isT2Bold ? 'FontBold' : '',
                          item.data[a].isT2Line ? 'FontLine' : '',
                        ]"
                      >
                        {{ item.data[a].t2 }}
                      </p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div
      class="w-7/12 pb-0 relative bottom-52"
      style="margin: 0 auto; text-align: center"
    >
      The best-performing model in each subset is <strong>in-bold</strong>, and
      the second best is <u>underlined</u>.
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      titles: [
        "Validation",
        "Test Overall",
        "PubMed",
        "SocialPath",
        "EduContent",
        "Atlas",
        "PathCLS",
      ],
      details: [
        {
          t1: 1111,
          t2: 1111,
        },
        {
          t1: 1156,
          t2: 9677,
        },
        {
          t1: 281,
          t2: 3068,
        },
        {
          t1: 235,
          t2: 1855,
        },
        {
          t1: 255,
          t2: 1938,
        },
        {
          t1: 208,
          t2: 1007,
        },
        {
          t1: 177,
          t2: 1809,
        },
      ],
      table1: [
        {
          prop: "Random Choice",
          sorce: "24.6",
          data: [
            // 第一个dict不用管
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 11.1,
              t2: 11.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 22.1,
              t2: 23.7,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 22.1,
              t2: 25.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 25.5,
              t2: 26.5,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 25.5,
              t2: "26.0",
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 19.7,
              t2: "23.0",
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 15.3,
              t2: 16.3,
            },
          ],
        },
        {
          prop: "Frequent Choice",
          sorce: "27.5",
          data: [
            // 第一个dict不用管
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 11.1,
              t2: 11.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 27.7,
              t2: 25.5,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 28.8,
              t2: 26.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 27.7,
              t2: 26.7,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 29.8,
              t2: 26.5,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 28.4,
              t2: 27.5,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: "22.0",
              t2: "21.0",
            },
          ],
        },
        {
          prop: "Expert performance",
          sorce: "-",
          data: [
            // 第一个dict不用管
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 11.1,
              t2: 11.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 71.8,
              t2: "-",
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 72.9,
              t2: "-",
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 71.5,
              t2: "-",
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: "69.0",
              t2: "-",
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 68.3,
              t2: "-",
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 78.9,
              t2: "-",
            },
          ],
        },
      ],
      table2: [
        {
          prop: "OpenFlamingo2-9B",
          link: "https://proceedings.neurips.cc/paper_files/paper/2022/hash/960a172bc7fbf0177ccccbb411a7d800-Abstract-Conference.html",
          sorce: "26.2",
          data: [
            // 占位(第一个dict不用管)
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 11.1,
              t2: 11.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 24.1,
              t2: 24.2,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 24.9,
              t2: 25.5,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 25.5,
              t2: 25.3,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 19.6,
              t2: 24.4,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 28.8,
              t2: 25.5,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: "22.0",
              t2: "20.4",
            },
          ],
        },
        {
          prop: "Kosmos2",
          link: "https://arxiv.org/abs/2306.14824",
          sorce: "26.9",
          data: [
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 11.1,
              t2: 11.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 26.1,
              t2: 24.9,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 27.8,
              t2: 25.8,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 27.2,
              t2: 24.3,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 25.1,
              t2: 25.9,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 23.1,
              t2: 24.2,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 27.1,
              t2: 22.8,
            },
          ],
        },
        {
          prop: "LLaMA-Adapter2-7B",
          link: "https://arxiv.org/abs/2304.15010",
          sorce: "26.2",
          data: [
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 11.1,
              t2: 11.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 26.6,
              t2: 26.4,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: "26.0",
              t2: 28.3,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 27.7,
              t2: 26.5,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 27.1,
              t2: "28.0",
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 30.8,
              t2: 27.4,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 20.9,
              t2: 20.5,
            },
          ],
        },
        {
          prop: "MiniGPT4-Vicuna-13B",
          link: "https://arxiv.org/abs/2304.10592",
          sorce: "27.2",
          data: [
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 11.1,
              t2: 11.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 25.5,
              t2: 27.7,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 28.8,
              t2: 30.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 24.3,
              t2: 27.2,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 25.5,
              t2: 29.3,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 27.9,
              t2: 28.6,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 19.2,
              t2: 21.8,
            },
          ],
        },
        {
          prop: "Otter",
          sorce: "26.1",
          link: "https://arxiv.org/abs/2305.03726",
          data: [
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 11.1,
              t2: 11.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 29.3,
              t2: 28.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 34.9,
              t2: 30.2,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: "26.0",
              t2: 28.4,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 30.6,
              t2: "30.0",
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 29.3,
              t2: 28.2,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 23.2,
              t2: 21.3,
            },
          ],
        },
        {
          prop: "Fuyu-8B",
          link: "https://www.adept.ai/blog/fuyu-8b",
          sorce: "27.5",
          data: [
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 11.1,
              t2: 11.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 30.1,
              t2: 29.2,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 35.9,
              t2: 30.5,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 28.9,
              t2: 30.7,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 30.6,
              t2: 29.8,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 27.9,
              t2: 30.6,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 24.3,
              t2: 23.9,
            },
          ],
        },
        {
          prop: "CogVLM",
          sorce: "29.9",
          link: "https://arxiv.org/abs/2311.03079",
          data: [
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 11.1,
              t2: 11.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 30.6,
              t2: 29.7,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: "32.0",
              t2: 32.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 31.1,
              t2: 30.4,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 30.6,
              t2: 29.9,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 35.1,
              t2: 33.7,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 22.6,
              t2: 22.4,
            },
          ],
        },
        {
          prop: "Owen-VL-7B",
          sorce: "29.4",
          link: "https://arxiv.org/abs/2308.12966",
          data: [
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 11.1,
              t2: 11.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 32.1,
              t2: 31.5,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 34.9,
              t2: 32.9,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 33.6,
              t2: 35.8,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 34.1,
              t2: 33.6,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 35.6,
              t2: 33.8,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 18.6,
              t2: 21.7,
            },
          ],
        },
        {
          prop: "BLIP-2 FLAN-T5-XL",
          sorce: "32.8",
          link: "https://arxiv.org/abs/2301.12597",
          data: [
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 11.1,
              t2: 11.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 32.6,
              t2: 31.8,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 35.9,
              t2: 34.6,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 34.9,
              t2: 33.6,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 33.7,
              t2: 32.8,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 34.6,
              t2: 37.4,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 20.3,
              t2: 20.8,
            },
          ],
        },
        {
          prop: "BLIP-2 FLAN-T5-XXL",
          sorce: "33.4",
          link: "https://arxiv.org/abs/2301.12597",
          data: [
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 11.1,
              t2: 11.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 33.3,
              t2: 33.5,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: "37.0",
              t2: 37.4,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 35.7,
              t2: 34.6,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 30.2,
              t2: 34.5,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 39.4,
              t2: 40.7,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 19.8,
              t2: 20.6,
            },
          ],
        },
        {
          prop: "InstructBLIP-FLAN-T5-XL",
          sorce: "33.1",
          link: "https://arxiv.org/abs/2305.06500",
          data: [
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 11.1,
              t2: 11.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 34.9,
              t2: 31.8,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: "37.0",
              t2: 33.2,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 35.3,
              t2: 33.9,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 36.5,
              t2: 33.3,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: "37.0",
              t2: 36.7,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 26.6,
              t2: 23.1,
            },
          ],
        },
        {
          prop: "InstructBLIP-FLAN-T5-XXL",
          sorce: "32.7",
          link: "https://arxiv.org/abs/2305.06500",
          data: [
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 11.1,
              t2: 11.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 34.3,
              t2: 33.9,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 39.1,
              t2: 37.2,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 33.6,
              t2: 34.3,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 34.5,
              t2: "36.0",
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 38.5,
              t2: 39.3,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 22.6,
              t2: 22.7,
            },
          ],
        },
        {
          prop: "LLaVA-1.5-7B",
          sorce: "36.6",
          link: "https://arxiv.org/abs/2304.08485",
          data: [
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 11.1,
              t2: 11.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 34.9,
              t2: 35.4,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 41.6,
              t2: 39.9,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 37.9,
              t2: 38.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 32.5,
              t2: 36.5,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 35.6,
              t2: 39.2,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 23.2,
              t2: 21.9,
            },
          ],
        },
        {
          prop: "LLaVA-1.5-13B",
          sorce: "37.9",
          link: "https://arxiv.org/abs/2304.08485",
          data: [
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 11.1,
              t2: 11.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 38.8,
              t2: 37.6,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 44.5,
              t2: "41.0",
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 40.4,
              t2: 40.4,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 34.1,
              t2: 39.4,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 47.1,
              t2: 44.3,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 24.9,
              t2: 23.5,
            },
          ],
        },
        {
          prop: "Qwen-VL-PLUS",
          sorce: "38.0",
          link: "https://arxiv.org/abs/2308.12966",
          data: [
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 11.1,
              t2: 11.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 39.3,
              t2: 34.3,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 43.5,
              t2: 37.7,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 41.3,
              t2: "36.0",
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 39.6,
              t2: "36.0",
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 44.7,
              t2: 37.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 23.2,
              t2: 23.3,
            },
          ],
        },
        {
          prop: "Qwen-VL-MAX",
          sorce: "43.6",
          link: "https://arxiv.org/abs/2308.12966",
          data: [
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 11.1,
              t2: 11.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 49.2,
              t2: 45.9,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: "53.0",
              t2: 50.9,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 53.6,
              t2: 49.3,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 52.2,
              t2: 47.9,
            },
            {
              isT1Bold: true,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 51.4,
              t2: 49.8,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 30.5,
              t2: 29.6,
            },
          ],
        },
        {
          prop: "Gemini Pro Vision",
          sorce: "41.9",
          link: "https://arxiv.org/abs/2312.11805",
          data: [
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 11.1,
              t2: 11.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 42.8,
              t2: 42.7,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 43.8,
              t2: 44.9,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 42.4,
              t2: "42.0",
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 43.5,
              t2: 43.7,
            },
            {
              isT1Bold: true,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 49.5,
              t2: 49.4,
            },
            {
              isT1Bold: true,
              isT2Bold: true,
              isT1Line: false,
              isT2Line: false,
              t1: 32.8,
              t2: 34.7,
            },
          ],
        },
        {
          prop: "GPT-4V",
          sorce: "49.3",
          link: "https://cdn.openai.com/papers/GPTV_System_Card.pdf",
          data: [
            {
              isT1Bold: true,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 11.1,
              t2: 11.1,
            },
            {
              isT1Bold: true,
              isT2Bold: true,
              isT1Line: false,
              isT2Line: false,
              t1: 53.9,
              t2: 49.8,
            },
            {
              isT1Bold: true,
              isT2Bold: true,
              isT1Line: false,
              isT2Line: false,
              t1: 59.4,
              t2: 53.5,
            },
            {
              isT1Bold: true,
              isT2Bold: true,
              isT1Line: false,
              isT2Line: false,
              t1: 58.7,
              t2: 53.9,
            },
            {
              isT1Bold: true,
              isT2Bold: true,
              isT1Line: false,
              isT2Line: false,
              t1: 60.4,
              t2: 53.6,
            },
            {
              isT1Bold: false,
              isT2Bold: true,
              isT1Line: false,
              isT2Line: false,
              t1: 48.1,
              t2: 52.8,
            },
            {
              isT1Bold: true,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 36.2,
              t2: 33.8,
            },
          ],
        },
      ],

      table3: [
        {
          prop: "ERNIE-Bot 4.0",
          sorce: "31.8",
          link: "https://arxiv.org/abs/2107.02137",
          data: [
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 11.1,
              t2: 11.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 34.3,
              t2: 30.9,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: "37.0",
              t2: 31.2,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 33.6,
              t2: 32.9,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: "40.0",
              t2: 34.5,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 36.1,
              t2: 37.4,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 20.9,
              t2: 20.6,
            },
          ],
        },
        {
          prop: "Gemini Pro",
          sorce: "31.0",
          link: "https://arxiv.org/abs/2312.11805",
          data: [
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 11.1,
              t2: 11.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 31.6,
              t2: "31.0",
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 31.3,
              t2: 33.5,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 31.9,
              t2: 31.4,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 33.3,
              t2: 32.7,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: "38.0",
              t2: 37.7,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 21.5,
              t2: 20.9,
            },
          ],
        },
        {
          prop: " Vicuna-v1.5-13B",
          sorce: "32.0",
          link: "https://lmsys.org/blog/2023-03-30-vicuna/",
          data: [
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 11.1,
              t2: 11.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 31.2,
              t2: 31.6,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 35.2,
              t2: 33.8,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 30.6,
              t2: 34.3,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 31.0,
              t2: 33.5,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 34.6,
              t2: 35.7,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 22.0,
              t2: 20.7,
            },
          ],
        },
        {
          prop: "GPT-3.5 Turbo",
          sorce: "30.4",
          link: "https://openai.com/blog/chatgpt",
          data: [
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 11.1,
              t2: 11.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 29.4,
              t2: 28.4,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 32.7,
              t2: 31.2,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 31.5,
              t2: 30.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 31.0,
              t2: 30.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 26.9,
              t2: 26.8,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: false,
              isT2Line: false,
              t1: 22.0,
              t2: 20.8,
            },
          ],
        },
        {
          prop: "GPT-4 Turbo",
          sorce: "36.5",
          link: "https://cdn.openai.com/papers/GPTV_System_Card.pdf",
          data: [
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: true,
              isT2Line: false,
              t1: 11.1,
              t2: 11.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: true,
              isT2Line: true,
              t1: 41.8,
              t2: 38.1,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: true,
              isT2Line: true,
              t1: 48.8,
              t2: 42.4,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: true,
              isT2Line: true,
              t1: 43.4,
              t2: 42.3,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: true,
              isT2Line: true,
              t1: 47.1,
              t2: 40.6,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: true,
              isT2Line: true,
              t1: 41.3,
              t2: 43.2,
            },
            {
              isT1Bold: false,
              isT2Bold: false,
              isT1Line: true,
              isT2Line: true,
              t1: 22.3,
              t2: 21.1,
            },
          ],
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
.Experiments {
  .bg {
    background-color: #f5f5f5;
    color: rgba(0, 0, 0, 0.7);
  }

  .table {
    margin: 10px;
    border-top: 4px solid #000;
    border-bottom: 4px solid #000;
    width: 100%;
  }

  .one {
    flex: 1.4;
  }
  .one:hover {
    color: rgb(119, 119, 196);
  }
  ul {
    display: flex;
    width: 100%;
    list-style-type: none;
    flex-flow: wrap;
  }
  .two {
    flex: 1;
    text-align: center;
    display: flex;
    flex-direction: column;
    font-size: 24px;
    font-family: Arial, sans-serif;
  }
  .first-column {
    flex: 2; /* 调整宽度 */
  }
  .three {
    flex: 1;
    text-align: center;
    font-size: 20px;
    font-family: Arial, sans-serif;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .name {
    display: flex;
    justify-content: space-around;
  }
  .details {
    width: 100%;
    font-size: 20px;
    bottom: 0;
  }
  .table-2 {
    border-top: 2px solid #000;
    border-bottom: 2px solid #000;
    padding: 10px 0;
  }
  .row-1 {
    display: flex;
    font-size: 20px;
  }
  .title-2 {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    font-family: Arial, sans-serif;
    font-weight: bold;
    padding: 20px;
  }
  a {
    // text-decoration: none;
  }
  .FontBold {
    font-weight: bold;
  }
  .FontLine {
    text-decoration: underline;
  }
}
</style>
